export const LOAD_REPORTS_SUCCESS = "LOAD_REPORTS_SUCCESS";
export const LOAD_REPORTS_FAILED = "LOAD_REPORTS_FAILED";
export const LOAD_REPORTS = "LOAD_REPORTS";
export const SELECT_FILTER_REPORTS = "SELECT_FILTER_REPORTS";
export const DOWNLOAD_REPORT = "DOWNLOAD_REPORT";
export const DOWNLOAD_REPORT_SUCCESS = "DOWNLOAD_REPORT_SUCCESS";
export const DOWNLOAD_REPORT_FAILED = "DOWNLOAD_REPORT_FAILED";


// WEBPACK FOOTER //
// ./src/reports/reportActionTypes.js